import { LightType } from "../types/Types";

export function getLayerImagePath(sampleId: string, lightType: LightType): string {
  return `${sampleId}/layers/${LightType[lightType].toLowerCase()}`;
}

export function getInterestAreaImagePath(sampleId: string, interstAreaId: string, lightType: LightType): string {
  return `${sampleId}/areas/${interstAreaId}/${LightType[lightType].toLowerCase()}`;
}